import { styled } from '@mui/material';
import { HelixPalette } from '../../../helix';
/**
 * Base styles for an input and textarea.
 */
const field = {
    //Remove mui styles for input as styling outer input div with scss
    width: '100%',
    border: 'none',
    '&:focus': { border: 'none', outline: 'none' },
    '&:hover:not([data-error=true]):not(:disabled)': { border: 'none' },
    '&:active:focus:not([data-error=true]):not(:disabled)': { border: 'none' },
    '&[data-active=true]:not([data-error=true]):not(:disabled)': {
        border: 'none',
    },
    '&:focus-visible': {
        border: 'none',
    },
    '&[data-error=true]:not(:disabled)': { border: 'none', paddingRight: '40px' },
    '&:disabled': {
        backgroundColor: HelixPalette.neutral10,
        border: 'none',
        cursor: 'not-allowed',
    },
};
/**
 * Helix styled input.
 */
export const HelixInput = styled('input')(() => (Object.assign(Object.assign({}, field), { 
    //Reduce height by 2px to allow for boarder on input div
    height: '36px' })));
/**
 * Helix styled textarea.
 */
export const HelixTextArea = styled('textarea')(() => (Object.assign(Object.assign({}, field), { resize: 'none' })));
